import type { IconProps as SurfaceIconProps } from '@ankhorage/surface';

import type { ZoraBaseProps } from './base';

export type IconProps = ZoraBaseProps & SurfaceIconProps;
